import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult, DataSourceRequestState } from "@progress/kendo-data-query";
import { Observable } from "rxjs";
import { AppConstant } from "src/app/app.constant";
import { map } from "rxjs/operators";


@Injectable()
export class AuditLogService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    public getAllAuditLog(state): Observable<DataResult> {
        return this.httpClient.post(`${this.apiUrl}/getAllAuditLog/`, state).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
}